/* global BMapGL, BMapGL BMapGLLib */
import loadBMap from './loadBMap';
import { ExtendedLuShu } from './extendedLuShu';
import './Lushu';

const ICON_WIDTH = 26;
const ICON_HEIGHT = 38;

// 起点标注点icon
const createSendingIcon = () =>
    new BMapGL.Icon(require('./images/shi_ztb.png'), new BMapGL.Size(ICON_WIDTH, ICON_HEIGHT), {
        imageSize: new BMapGL.Size(ICON_WIDTH, ICON_HEIGHT)
    });

// 终点标注点icon
const createReceivingIcon = () =>
    new BMapGL.Icon(require('./images/zhong_ztb.png'), new BMapGL.Size(ICON_WIDTH, ICON_HEIGHT), {
        imageSize: new BMapGL.Size(ICON_WIDTH, ICON_HEIGHT)
    });

// 始发点标注点icon
const createOriginationIcon = () =>
    new BMapGL.Icon(require('./images/start.png'), new BMapGL.Size(32, 32), {
        imageSize: new BMapGL.Size(32, 32)
    });

// 收货点标注点icon
const createTakeOverIcon = () =>
    new BMapGL.Icon(require('./images/end.png'), new BMapGL.Size(32, 32), {
        imageSize: new BMapGL.Size(32, 32)
    });

// 接单标注点icon
const orderReceiving = () =>
    new BMapGL.Icon(require('./images/order-receiving.png'), new BMapGL.Size(ICON_WIDTH, ICON_HEIGHT), {
        imageSize: new BMapGL.Size(ICON_WIDTH, ICON_HEIGHT)
    });

// 轨迹标注点icon
const trackIcon = () =>
    new BMapGL.Icon(require('./images/track.png'), new BMapGL.Size(6, 6), {
        imageSize: new BMapGL.Size(6, 6)
    });

// 车辆标注点icon
const createCarMarkerIcon = () =>
    new BMapGL.Icon(require('./images/car.png'), new BMapGL.Size(48, 48), {
        imageSize: new BMapGL.Size(48, 48)
    });

/**
 * @description 初始化地图实例
 * @param {String} mapId 地图实例id
 * @param {Function} controller 类
 */
export const infoMap = async (mapId, controller) => {
    await loadBMap();
    const map = new BMapGL.Map(mapId);
    // 允许地图可被鼠标滚轮缩放
    map.enableScrollWheelZoom();
    // 开启地图的平移缩放控件 TODO GL版本没有这个控件
    // const navigationControl = new BMapGL.NavigationControl({
    //     offset: new BMapGL.Size(10, 10),
    //     anchor: 'BMAP_ANCHOR_BOTTOM_LEFT',
    //     type: 'BMAP_NAVIGATION_CONTROL_LARGE',
    //     enableGeolocation: true
    // });
    // map.addControl(navigationControl);
    const scaleCtrl = new BMapGL.ScaleControl(); // 添加比例尺控件
    map.addControl(scaleCtrl);
    const zoomCtrl = new BMapGL.ZoomControl(); // 添加缩放控件
    map.addControl(zoomCtrl);
    // 设置中心点
    map.centerAndZoom(new BMapGL.Point('113.216596', '22.913121'), '15');
    controller.bindMap(map, {});
};
/**
 * @description 创建开始和结束标注点
 * @param {Object} map 地图实例
 * @param {Object} point 开始和结束坐标
 * @param {Function} icon 开始和结束图标
 * @param {Object} pointData 开始和结束信息
 * @param {Object} offset 偏移量
 * @returns {Object} 返回注册的标注点
 */
function createRouteMarker (map, { point, icon, pointData, offset }) {
    // 创建Marker实例
    const marker = new BMapGL.Marker(point, {
        icon,
        offset
    });
    map.addOverlay(marker);
    const content = `
        <div class="trace-hover-ctn">
            <p>运输点:${pointData.siteAddress || pointData.trackingLocationName}</p>
            ${pointData.requireDepartTime ? '<p>要求出发时间:' + pointData.requireDepartTime + '</p>' : ''}
            ${pointData.requireArriveTime ? '<p>要求到达时间:' + pointData.requireArriveTime + '</p>' : ''}
            ${pointData.actDepartTime ? '<p>实际出发时间:' + pointData.actDepartTime + '</p>' : ''}
            ${pointData.actualArriveDate ? '<p>实际到达时间:' + pointData.actualArriveDate + '</p>' : ''}
            ${pointData.arrivalTime ? '<p>实际抵达时间:' + pointData.arrivalTime + '</p>' : ''}
            <p>地址:${pointData.siteAddress || pointData.trackingLocationName}</p>
        </div>`;
    addClickHandler(map, {
        marker,
        content,
        point
    });
    return marker;
}
/**
 * @description 标注弹窗点点击事件
 * @param {Object} map 地图实例
 * @param {Object} marker 标注点实例
 * @param {String} content 弹窗内容
 * @param {Object} point 标注点坐标
 */

function addClickHandler (map, { marker, content, point }) {
    marker.addEventListener('click', function () {
        const infoWindow = new BMapGL.InfoWindow(content, {
            width: 600
        });
        map.openInfoWindow(infoWindow, point); // 开启信息窗口
    });
}

/**
 * @description 车辆轨迹注点
 * @param {Object} map 地图实例
 * @param {Object} point 开始和结束坐标
 * @param {Function} icon 开始和结束图标
 * @param {Object} pointData 开始和结束信息
 * @returns {Object} 返回注册的标注点
*/
function createCarRouteMarker (map, { point, icon, pointData, offset }) {
    // 创建Marker实例
    const marker = new BMapGL.Marker(point, {
        icon,
        offset
    });
    map.addOverlay(marker);
    const content = pointContent(pointData);
    hoverClickHandler(map, {
        marker,
        content,
        point
    });
    return marker;
}

/**
 * @description 标注弹窗移入移出事件
 * @param {Object} map 地图实例
 * @param {Object} marker 标注点实例
 * @param {String} content 弹窗内容
 * @param {Object} point 标注点坐标
 */

function hoverClickHandler (map, { marker, content, point }) {
    marker.addEventListener('mouseover', function () {
        const infoWindow = new BMapGL.InfoWindow(content, {
            title: '当前轨迹点'
        });
        map.openInfoWindow(infoWindow, point); // 开启信息窗口
    });
    marker.addEventListener('mouseout', function () {
        const infoWindow = new BMapGL.InfoWindow(content);
        map.closeInfoWindow(infoWindow, point); // 开启信息窗口
    });
}

/**
 * @description 创建线图层
 * @param {Object} map 地图实例
 * @param {Array} options // 需要绘制图层的坐标
*/

function createLineLayer (map, { options }) {
    const lineLayer = new BMapGL.LineLayer({
        autoSelect: true,
        opacity: 0.3,
        pickWidth: 30,
        pickHeight: 30,
        selectedColor: '#0094ff', // 选中项颜色
        style: { // 配置样式
            sequence: false,
            borderColor: 'rgba(0, 148, 255, .6)',
            borderWeight: 2,
            strokeWeight: 3,
            strokeStyle: 'dashed'
        }
    });
    const testLineData = options.map(item => {
        return [item.lng, item.lat];
    });
    const featureCollectionData = {
        type: 'FeatureCollection',
        features: [
            {
                type: 'Feature',
                properties: {
                    name: 'demo1'
                },
                geometry: {
                    type: 'LineString',
                    coordinates: testLineData
                }
            }
        ]
    };
    lineLayer.setData(featureCollectionData);
    map.addNormalLayer(lineLayer);
}

/**
 * @description 转换为地图实例
 * @param {Object} pos 需要转换的坐标
 * @returns {Object}
 */
function toLinePoint (pos) {
    return new BMapGL.Point(pos.longitude, pos.latitude);
}
/**
 * @description 司机文本标注框
 * * @param {Object} map 地图实例
 * @param {Object} point 司机文本标注框的坐标
 * @param {Object} pointData 司机文本标注框的内容
 */
function driverTextMarker (map, { point, pointData }) {
    const content = `
        <div style="display: flex;word-break: break-word;white-space: pre-line;">
        <div style="width:40px">地址:</div>
        <span>${pointData.trackingLocationName}</span>
        </div>
        <div>运输工具: ${pointData.vehicleCard}</div>
        <div>驾驶员: ${pointData.driver}</div>
        <div>手机:  ${pointData.driverContactWay}</div>
        `;
    const label = new BMapGL.Label(content, {
        position: point,
        offset: new BMapGL.Size(20, -10)
    });
    label.setStyle({
        width: '300px',
        fontSize: '14px',
        padding: '5px',
        borderColor: '#fff',
        borderRadius: '5px'
    });
    map.addOverlay(label);
}

/**
 * @description 当前轨迹点标注信息
 * @param {Object} data 当前轨迹定位信息
 */
export const pointContent = data => {
    return `
        <div style="text-align:left;padding-left:-20px;font-size:12px;">
        <div style="display: flex;word-break: break-word;white-space: pre-line;">
        <div>轨迹点地址:${data.trackingLocationName || ''}</div>
        </div>
        <div>打点时间: ${data.trackingDate || ''}</div>
        <div>当前车速: ${data.speed || ''}km/h</div>
        <div>经纬度:  ${data.longitude || ''}/${data.latitude || ''}</div>
        </div> `;
};

export class TraceRouteController {
    /**
     * @description 在类里面注册实例
     * @param {Object} map 地图实例
     */
    bindMap (map) {
        this.map = map;
        this.markers = new Map();
    }

    /**
     * @description 创建有图标的标注点
     * @param {String} markerGroupName TODO
     * @param {Object} point 标注点坐标
     * @param {Function} createIcon 标注点图标
     * @param {Function} createMarker 创建标注点方法
     * @param {Object} offset 偏移量
     */
    addIconMarker (markerGroupName, point, createIcon, createMarker, offset = new BMapGL.Size(0, 0)) {
        const markers = this.markers.get(markerGroupName) || [];
        markers.push(
            createMarker(this.map, {
                point: toLinePoint(point),
                icon: createIcon(),
                pointData: point,
                offset
            })
        );
        this.markers.set(markerGroupName, markers);
    }

    /**
     * @description 移除标注点和清空MAP数组里存储的参数
     */
    removeMarkers () {
        this.map.clearOverlays();
        this.markers = new Map();
    }

    /**
     * @description 地图最佳视角
     */
    handleViewport () {
        const linePoints = [];
        for (const val of this.markers.values()) {
            val.forEach(e => {
                linePoints.push(e);
            });
        }
        this.map.setViewport(linePoints);
    }

    /**
     * @description 绘制线路
     * @param {Array} routeData 绘制线路的数据
     */
    setRouteData (routeData) {
        const markerGroupName = 'driving-Route';
        // this.removeMarkers(markerGroupName);
        const linePoints = [];
        for (const data of routeData) {
            linePoints.push(toLinePoint(data));
        }
        const start = {
            longitude: routeData[0].longitude,
            latitude: routeData[0].latitude,
            requireDepartTime: routeData[0].requireDepartTime,
            requireArriveTime: routeData[0].requireArriveTime,
            actDepartTime: routeData[0].actDepartTime,
            actualArriveDate: routeData[0].actualArriveDate,
            arrivalTime: routeData[0].arrivalTime,
            siteAddress: routeData[0].siteAddress
        };
        const end = {
            longitude: routeData[routeData.length - 1].longitude,
            latitude: routeData[routeData.length - 1].latitude,
            requireDepartTime: routeData[routeData.length - 1].requireDepartTime,
            requireArriveTime: routeData[routeData.length - 1].requireArriveTime,
            actDepartTime: routeData[routeData.length - 1].actDepartTime,
            actualArriveDate: routeData[routeData.length - 1].actualArriveDate,
            arrivalTime: routeData[routeData.length - 1].arrivalTime,
            siteAddress: routeData[routeData.length - 1].siteAddress
        };
        this.addIconMarker(markerGroupName, start, createSendingIcon, createRouteMarker);
        this.addIconMarker(markerGroupName, end, createReceivingIcon, createRouteMarker);
        this.markers.set(markerGroupName, linePoints);
    }
    /**
     * @description 车辆轨迹绘制
     * @param {Array} carData 绘制线路的数据
     * @param {Boolean} orderTakingFlag 是否展示接单点
     */
    setCarRouteData (carData, orderTakingFlag) {
        const markerGroupName = 'car-route-marker';
        // 用于存储处理接单点、收货点、始发点以外的坐标点
        this.options = JSON.parse(JSON.stringify(carData));
        // 获取起始点和终点  displayType === 0 的就是起始点 接单点取最后一条，终点取第一条
        const startDotIndex = carData.findIndex(item => item.displayType === 0);

        const pointsList = [];
        for (const data of carData) {
            pointsList.push(toLinePoint(data));
        }
        if (orderTakingFlag) {
            const orderTaking = {
                longitude: carData[carData.length - 1].longitude,
                latitude: carData[carData.length - 1].latitude,
                trackingDate: carData[carData.length - 1].trackingDate,
                trackingLocationName: carData[carData.length - 1].trackingLocationName
            };
            this.addIconMarker(markerGroupName, orderTaking, orderReceiving, createCarRouteMarker);
            this.options.splice(carData.length - 1, 1);
        }

        // 轨迹线路是展示从起点到终点，然后打点数据没有起点标识的话，也不展示终点，不绘制轨迹不支持回放了
        if (startDotIndex !== -1 || startDotIndex !== 0) {
            const start = {
                longitude: carData[startDotIndex].longitude,
                latitude: carData[startDotIndex].latitude,
                speed: carData[startDotIndex].speed,
                trackingDate: carData[startDotIndex].trackingDate,
                trackingLocationName: carData[startDotIndex].trackingLocationName
            };

            const end = {
                longitude: carData[0].longitude,
                latitude: carData[0].latitude,
                speed: carData[0].speed,
                trackingDate: carData[0].trackingDate,
                trackingLocationName: carData[0].trackingLocationName
            };
            if (this.options.length > 2) {
                this.options.splice(0, 1);
                this.options.splice(startDotIndex, 1);
                this.options.forEach(e => {
                    this.addIconMarker(markerGroupName, e, trackIcon, createCarRouteMarker);
                });
            }
            const linePoints = [];
            // 不改变原数组的情况下，反转数组
            const dotData = [...carData].reverse();
            for (const data of dotData) {
                linePoints.push(toLinePoint(data));
            }

            this.addIconMarker(markerGroupName, start, createOriginationIcon, createCarRouteMarker);
            this.addIconMarker(markerGroupName, end, createTakeOverIcon, createCarRouteMarker);
            const polyline = new BMapGL.Polyline(linePoints, {
                strokeColor: '#0094ff',
                strokeOpacity: 0.3,
                strokeWeight: 6
            });

            // createLineLayer(this.map, { options: pointsList });
            this.map.addOverlay(polyline);
            this.startLushu(polyline.getPath());
        }
        this.markers.set(markerGroupName, pointsList);
    }

    /**
     * @description 司机位置文本标注框假数据和车辆坐标点绘制
     * @param {Object} point 车辆坐标点
     */
    setCarMarker (point) {
        const markerGroupName = 'car-marker';
        const carPoint = toLinePoint(point);
        this.addIconMarker(markerGroupName, point, createCarMarkerIcon, createRouteMarker, new BMapGL.Size(0, -20));
        // driverTextMarker(this.map, {
        //     point: carPoint,
        //     pointData: point
        // });
        this.markers.set(markerGroupName, [carPoint]);
        this.map.addOverlay(carPoint);
    }

    /**
     * @description 创建路书实例
     * @param {Object} polyline 车辆坐标点
    */
    startLushu (polyline) {
        const lushu = new BMapGLLib.LuShu(this.map, polyline, {
            geodesic: true,
            autoCenter: true,
            icon: new BMapGL.Icon(require('./images/car.png'), new BMapGL.Size(48, 48), { anchor: new BMapGL.Size(24, 24) }),
            speed: 10000,
            enableRotation: true
        });
        this.lushu = new ExtendedLuShu({
            map: this.map,
            lushu
        });
    }

    start () {
        if (this.lushu) {
            this.lushu.start();
        }
    }

    pause () {
        if (this.lushu) {
            this.lushu.pause();
        }
    }

    setSpeed (n) {
        if (this.lushu) {
            this.lushu.setSpeed(10000 * n);
        }
    }

    onMove (fn) {
        if (this.lushu) {
            this.lushu.on('move', fn);
        }
    }

    onClear () {
        if (this.lushu) {
            this.lushu.clear();
        }
    }
}
